import React, { Component } from "react";

class AuditoriaTopico extends Component {
  render() {
    let styleContraste = {
      border: "1px dashed #777",
      fontWeight: "700",
      background: "#fff"
    }

    return (
      <div className="row">
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <h4 className="card-title">TÓPICOS DISCUTIDOS</h4>
                </div>
              </div>
              {this.props.topicos.map(
                function (topico, i) {
                  return (
                    <div key={i} className="form-group row">
                      <textarea
                        style={styleContraste}
                        disabled
                        rows="5"
                        placeholder="NÃO INFORMADO"
                        name="descricao"
                        className="form-control"
                        value={topico.descricao}
                      />
                    </div>
                  );
                }
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AuditoriaTopico;